import { FC, useEffect, memo } from 'react';

import MainLayout from '../../../shared/common/components/layouts/MainLayout';
import Loader from '../../../shared/common/components/loader/Loader';
import ReportChart from '../../../shared/common/components/reports/chart/ReportChart';
import FirstRegIcon from '../../../shared/common/components/reports/params/attribution/icons/FirstRegIcon';
import LastRegIcon from '../../../shared/common/components/reports/params/attribution/icons/LastRegIcon';
import TypeIcon from '../../../shared/common/components/reports/params/attribution/icons/TypeIcon';
import Params from '../../../shared/common/components/reports/params/Params';
import UniversalReportTitle from '../../../shared/common/components/reports/un-title/UniversalReportTitle';
import { listKeysGroupings } from '../../../shared/common/components/reports/visit-table/components/Groupings';
import { listKeysMetrics } from '../../../shared/common/components/reports/visit-table/components/Metrics';
import ReportTable from '../../../shared/common/components/reports/report-table';
import { chartDetails } from '../../../shared/common/constants/details';
import { createAttrItems } from '../../../shared/common/constants/report-constants';
import { useReportPageInit } from '../../../shared/common/hooks/useReportPageInit';

interface MetricListItem {
  dataKey: string;
  name?: string;
  label?: string;
  [key: string]: unknown;
}

interface GroupingListItem {
  dataKey: string;
  name?: string;
  label?: string;
  [key: string]: unknown;
}

const defaultMetricsOrderNotPrepare = [
  // Дефолтные метрики
  'regs_count_6',
  'visitors_count_6',
  'hits_count_6',
  'orders_count_6',
].map((dataKey) =>
  listKeysMetrics.find((item: MetricListItem) => item.dataKey === dataKey)
);

export const defaultMetricsVisits = defaultMetricsOrderNotPrepare
  .filter((item): item is MetricListItem => item !== undefined)
  .map((item) => ({ ...item }));

const defaultGroupingsOrderNotPrepare = [
  // Дефолтные группировки
  'first_hit_url_6',
  'hit_url_6',
].map((dataKey) =>
  listKeysGroupings.find((item: GroupingListItem) => item.dataKey === dataKey)
);

export const defaultGroupingsVisits = defaultGroupingsOrderNotPrepare
  .filter((item): item is GroupingListItem => item !== undefined)
  .map((item) => ({ ...item }));

const Visits: FC = () => {
  // Используем универсальный хук для инициализации страницы отчёта
  const { isChartLoading } = useReportPageInit({
    defaultMetrics: defaultMetricsVisits,
    defaultGroupings: defaultGroupingsVisits,
  });
  
  useEffect(() => {
    document.body.style.overflow = 'scroll';
    document.body.style.overflowX = 'auto';
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowX = '';
    };
  }, []);
  
  const attrItems = createAttrItems(<TypeIcon />, <FirstRegIcon />, <LastRegIcon />);
  
  return (
    <MainLayout pageTitle="Отчёт по посещениям">
      <div className="page-wrapper">
        <div className="page-content">
          <UniversalReportTitle />
          <Params
            filtersFilter={[
              'Пользователи',
              'Регистрации',
              'Заявки',
              'Заказы',
              'Платежи',
              'Вебинары',
            ]}
            attributionItems={attrItems}
            detailsItems={chartDetails}
          />
          <Loader loading={isChartLoading}>
            <ReportChart reportType="visit" />
          </Loader>
          <ReportTable reportType="visit" />
        </div>
      </div>
    </MainLayout>
  );
};

export default memo(Visits);
